import { render, staticRenderFns } from "./FormRadioStackInline.vue?vue&type=template&id=2874fb2c&"
import script from "./FormRadioStackInline.vue?vue&type=script&lang=js&"
export * from "./FormRadioStackInline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports